export default __webpack_public_path__ + "static/media/firefighter.50556347.png";